import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { CoverImage } from './CoverImage';
import { SectionEyebrow } from './SectionEyebrow';
import { trackInitiateCheckout } from '../lib/metaPixel';
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/k66PeTHA9hMBB1F8f8BeHQ/42AD1564-0724-4E06-956B-1E54FA235ABC.png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/nhed4qrh1e2fpNSZrdGvyC/Gemini_Generated_Image_o3coy2o3coy2o3co.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/dSf1KMiKPp2oVvK3GHV7AG/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(1).png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/5MGNjuQNrJY9EmSncq3zok/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(2).png',
  paola: 'https://cdn.magicpatterns.com/uploads/22mDh6LQEczAscrxi2KaJW/BE22049D-3AC8-40A4-985F-FFD76A0932A4.png'
};
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[95vh] flex flex-col justify-center overflow-hidden bg-background pt-24 pb-16 md:pt-32 md:pb-24 px-6" data-id="element-98">
      {/* Soft background glow & ornament */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-card/60 rounded-full blur-[120px] pointer-events-none" data-id="element-99"></div>
      <Sparkles className="absolute top-20 right-20 w-64 h-64 text-accent opacity-5 pointer-events-none" data-id="element-100" />

      <div className="container max-w-[1200px] mx-auto relative z-10 flex-grow flex flex-col justify-center" data-id="element-101">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-102">
          {/* Left Column: Paola's Portrait */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1.2,
          ease: 'easeOut'
        }} className="lg:col-span-5 relative order-2 lg:order-1" data-id="element-103">
            <div className="relative rounded-xl overflow-hidden shadow-soft border border-border/50" data-id="element-104">
              <img src={IMAGES.paola} alt="Paola Rojas" className="w-full h-[500px] lg:h-[650px] object-cover object-top" data-id="element-105" />
              {/* Museum frame offset effect */}
              <div className="absolute inset-4 border border-accent/30 rounded-lg pointer-events-none" data-id="element-106"></div>
            </div>

            {/* Floating Main Ebook Cover */}
            <motion.div initial={{
            opacity: 0,
            y: 20,
            rotate: -5
          }} animate={{
            opacity: 1,
            y: 0,
            rotate: -5
          }} transition={{
            duration: 1,
            delay: 0.5
          }} className="absolute -bottom-10 -right-6 lg:-right-12 w-[180px] lg:w-[220px] z-20" data-id="element-107">
              <CoverImage src={IMAGES.main} alt="Glow Up Femenino" data-id="element-108" />
            </motion.div>
          </motion.div>

          {/* Right Column: Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          ease: 'easeOut',
          delay: 0.2
        }} className="lg:col-span-7 flex flex-col items-center text-center lg:items-start lg:text-left order-1 lg:order-2 z-10" data-id="element-109">
            <SectionEyebrow text="Por Paola Rojas · Una experiencia digital" className="mb-6" data-id="element-110" />

            <h1 className="text-6xl md:text-7xl lg:text-8xl leading-[1.05] text-foreground mb-4 font-light" data-id="element-111">
              Vuelve a ti.
            </h1>
            <h2 className="text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground mb-8 font-serif" data-id="element-112">
              Construye la mujer <br className="hidden lg:block" data-id="element-113" />
              que <span className="italic text-muted-foreground" data-id="element-114">admiras.</span>
            </h2>

            <p className="text-lg md:text-xl text-muted-foreground font-light leading-relaxed max-w-xl mb-10" data-id="element-115">
              Una experiencia de transformación para sanar emocionalmente,
              reconstruir tu identidad y convertirte en la mujer que Dios diseñó
              que fueras. Segura, femenina, alineada y en paz.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4 w-full" data-id="element-116">
              <a href="https://bypaolarojas.com/products/glow-up-femenino-en-30-dias?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="bg-primary text-primary-foreground px-10 py-5 rounded-full font-sans text-base tracking-wide hover:bg-primary/90 transition-all duration-300 shadow-soft hover:shadow-lg hover:-translate-y-0.5 w-full md:w-auto text-center inline-block" data-id="element-117">
                Quiero comenzar mi transformación
              </a>
              <p className="text-sm text-muted-foreground tracking-wide font-light" data-id="element-118">
                Hoy{' '}
                <span className="font-serif italic text-foreground" data-id="element-119">
                  $19.99 USD
                </span>{' '}
                · Antes{' '}
                <span className="line-through opacity-60" data-id="element-120">$999 USD</span> ·
                Acceso inmediato
              </p>
            </div>
          </motion.div>
        </div>

        {/* Bottom Strip: Flatlay */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-24 lg:mt-32 pt-12 border-t border-border/50 flex flex-col items-center" data-id="element-121">
          <p className="text-xs uppercase tracking-[0.2em] text-accent mb-8" data-id="element-122">
            Ebook + 3 bonos · Colección completa
          </p>
          <div className="flex justify-center items-center -space-x-4 md:-space-x-8" data-id="element-123">
            <div className="w-24 md:w-32 z-10" data-id="element-124">
              <CoverImage src={IMAGES.bonus1} alt="Bono 1" rotation={-8} hoverEffect={false} data-id="element-125" />
            </div>
            <div className="w-28 md:w-40 z-30" data-id="element-126">
              <CoverImage src={IMAGES.main} alt="Principal" rotation={0} hoverEffect={false} data-id="element-127" />
            </div>
            <div className="w-24 md:w-32 z-20" data-id="element-128">
              <CoverImage src={IMAGES.bonus2} alt="Bono 2" rotation={6} hoverEffect={false} data-id="element-129" />
            </div>
            <div className="w-20 md:w-28 z-10" data-id="element-130">
              <CoverImage src={IMAGES.bonus3} alt="Bono 3" rotation={12} hoverEffect={false} data-id="element-131" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}